import styled, { css } from 'styled-components';

import fontStyles from '@shared/design-tokens/fontStyles';
import colors from '@shared/design-tokens/colors';

import variants from './variants';

const color = (_color = 'black') => ({
  color: `${_color}`,
});

const baseComponentCSS = css`
  ${{
    margin: '0px',
    padding: '0px',
    ...color(),
  }}
`;

const defaultStateCSS = css`
  ${({ variant }) => {
    const defaultStyles = {
      [variants.darkBlue]: {
        ...color(colors.core.darkBlue),
      },
      [variants.white]: {
        ...color(colors.white),
      },
      [variants.coral]: {
        ...color(colors.core.coral),
      },
      [variants.callToAction]: {
        ...color(colors.core.callToAction),
      },
      [variants.error]: {
        ...color(colors.errorRedPrimary),
      },
      [variants.gray]: {
        ...color(colors.gray1),
      },
      [variants.black]: {
        ...color(colors.black),
      },
    };
    return defaultStyles[variant] || defaultStyles[variants.darkBlue];
  }}
`;

/** styled-components */
const commonCSS = css`
  ${baseComponentCSS}

  ${defaultStateCSS}

  ${({ type }) => type && fontStyles.core[type]}
  ${({ whiteSpace }) => whiteSpace && { whiteSpace }}
`;

export const H1 = styled.h1`
  ${commonCSS}
`;
export const H2 = styled.h2`
  ${commonCSS}
`;
export const H3 = styled.h3`
  ${commonCSS}
`;
export const H4 = styled.h4`
  ${commonCSS}
`;
export const Paragraph = styled.p`
  ${commonCSS}
`;
